import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './header.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
import * as $ from 'jquery';
var Header = /** @class */ (function (_super) {
    tslib_1.__extends(Header, _super);
    function Header(element) {
        var _this = _super.call(this, element) || this;
        _this.open = false;
        _this.accountOpen = false;
        _this.activeItem = '';
        _this.activeSecondaryItem = '';
        _this.activeTertiaryItem = '';
        _this.expanded = false;
        _this.header = element;
        return _this;
    }
    Header.prototype.init = function () {
        var _this = this;
        this.accountMenu = $('.header__secondary-bar-login');
        this.accountMobileMenu = $('.header__mobile-menu-user');
        this.accountDesktopMenu = $('.header__mobile-menu-user');
        this.hamburger = $('.js-hamburger');
        this.mobileMenu = $('.header__mobile-menu');
        this.megaNavTab = $('.header__mega-menu-nav-item');
        this.mobileAccountMenu = $('.header__mobile-menu-account');
        this.mobileMenuNav = $('.header__mobile-menu-nav');
        this.mobileMenuNavItem = $('.header__mobile-menu-nav-item');
        this.mobileMenuNavSecondaryItem = $('.header__mobile-menu-nav-secondary-item');
        this.mobileMenuNavTertiaryItem = $('.header__mobile-menu-nav-tertiary-item');
        this.mobileMenuNavTertiaryBack = $('.header__mobile-menu-nav-tertiary-back');
        var countrySelector = $('.country-selector').detach();
        $('.header').append(countrySelector);
        this.accountOpen = false;
        // group
        this.groupCountryInitContainer = Array.from(this.element.querySelectorAll('.js-group-country-container-init'));
        this.groupCountryInitContainerNotSelected = Array.from(this.element.querySelectorAll('.js-group-country-container__notselected'));
        this.groupCountryInitContainerSelected = Array.from(this.element.querySelectorAll('.js-group-country-container__selected'));
        this.groupCountryTrigger = Array.from(this.element.querySelectorAll('.js-group-country-select'));
        this.groupCountryContainer = Array.from(this.element.querySelectorAll('.js-group-country-container'));
        this.groupCountrySelected = Array.from(this.element.querySelectorAll('.js-group-country-selected'));
        this.groupCountryWebsite = Array.from(this.element.querySelectorAll('.js-group-country-website'));
        this.groupCountryCollapse = Array.from(this.element.querySelectorAll('.header__mega-menu--account__split--left .js-collapse-trigger'));
        this.groupCountryContainerLink = Array.from(this.element.querySelectorAll('.header__mega-menu--account__split--container-link'));
        // language selector
        if (this.element.querySelector('.header__top-bar-language')) {
            this.containerLanguagesDesktop = this.element.querySelector('.header__top-bar-language');
        }
        if (this.element.querySelector('.js-language-selector-desktop')) {
            this.buttonLanguageSelectorDesktop = this.element.querySelector('.js-language-selector-desktop');
        }
        if (this.element.querySelector('.js-language-selector-button-mobile')) {
            this.mobileMenuNavLanguageSelector = this.element.querySelector('.js-language-selector-button-mobile');
        }
        if (this.element.querySelector('.header__mobile-menu-language__overlay')) {
            this.mobileMenuNavLanguageOverlay = this.element.querySelector('.header__mobile-menu-language__overlay');
        }
        // quick fix for the BizConnect nav in header on Business Page
        this.bizConnectFix();
        // alert navigation changed
        this.detectMobileHeaderContentHeight();
        window.addEventListener('resize', function () {
            _this.detectMobileHeaderContentHeight();
        });
        ////////////////////////////////////
        ////////////////////////////////////
        // drawer menu
        ////////////////////////////////////
        ////////////////////////////////////
        if (this.element.querySelector('.header__onlinebanking')) {
            this.element.classList.add('header__onlinebanking--zindex');
            this.drawerButton = this.element.querySelector('.header__secondary-bar-login a');
            this.drawerComponent = this.element.querySelector('.header__onlinebanking');
            this.drawerContainer = this.element.querySelector('.header__onlinebanking--container');
            this.drawerClose = Array.from(this.element.querySelectorAll('.header__onlinebanking--container__close'));
            this.drawerMobileMenuButton = this.element.querySelector('.header__mobile-menu-user');
            if (this.element.querySelector('.header__onlinebanking--container__accordion--tab__label')) {
                this.headerOnlineBankingAccordion = Array.from(this.element.querySelectorAll('.header__onlinebanking--container__accordion--tab__label'));
            }
            var calculate = 130;
            if (document.querySelector('.header__alert')) {
                var alert_1 = document.querySelector('.header__alert');
                var alertHeight = alert_1.clientHeight;
                calculate = calculate + alertHeight;
            }
            if (document.querySelector('.open-app-store')) {
                var appStore = document.querySelector('.open-app-store');
                var appStoreheight = appStore.clientHeight;
                calculate = calculate + appStoreheight;
            }
            this.drawerContainer.style.height = 'calc(100vh - ' + calculate + 'px);';
        }
        ////////////////////////////////////
        ////////////////////////////////////
        // drawer cart
        ////////////////////////////////////
        ////////////////////////////////////
        if (this.element.querySelector('.header__onlinebanking--cart')) {
            this.element.classList.add('header__onlinebanking--cart--zindex');
            this.drawerCartButton = this.element.querySelector('.header__secondary-bar-cart__onlinebanking');
            this.drawerCartComponent = this.element.querySelector('.header__onlinebanking--cart');
            this.drawerCartContainer = this.element.querySelector('.header__onlinebanking--cart--container');
            this.drawerCartClose = Array.from(this.element.querySelectorAll('.header__onlinebanking--cart--container__close'));
            this.drawerCartMobileMenuButton = this.element.querySelector('.header__secondary-bar-cart__onlinebanking--mobile');
            var calculate = 130;
            if (document.querySelector('.header__alert')) {
                var alert_2 = document.querySelector('.header__alert');
                var alertHeight = alert_2.clientHeight;
                calculate = calculate + alertHeight;
            }
            if (document.querySelector('.open-app-store')) {
                var appStore = document.querySelector('.open-app-store');
                var appStoreheight = appStore.clientHeight;
                calculate = calculate + appStoreheight;
            }
            this.drawerCartContainer.style.height = 'calc(100vh - ' + calculate + 'px);';
        }
    };
    Header.prototype.bindEvents = function () {
        var _this = this;
        $('.js-country-selector-open').click(function () {
            _this.lastScrollTop = $(window).scrollTop();
            $('body').css({
                'overflow': 'hidden',
                'position': 'relative',
                'width': '100%'
            });
            $('.country-selector__modal').addClass('country-selector__modal--reveal');
        });
        $('.country-selector__close').click(function () {
            $('body').css({
                'overflow': '',
                'position': '',
                'width': ''
            });
            $(window).scrollTop(_this.lastScrollTop);
        });
        $(window).scroll(function () {
            _this.scroll();
        });
        this.hamburger.click('click', function () {
            _this.toggleMobileMenu();
            if (_this.mobileMenuNavLanguageSelector) {
                _this.mobileMenuNavLanguageSelector.classList.remove('header__mobile-menu-language__button__opened');
                _this.mobileMenuNavLanguageOverlay.classList.remove('header__mobile-menu-language__overlay--opened');
            }
        });
        this.accountMenu.click('click', function () {
            _this.toggleAccountMobileMenu();
        });
        this.accountMobileMenu.click('click', function () {
            _this.toggleAccountMobileMenu();
        });
        this.megaNavTab.click('click', function (event) {
            var megaNav = $(event.currentTarget).closest('.header__mega-menu');
            var section = $(event.currentTarget).data('section');
            $(megaNav).find('.header__mega-menu-nav-item').removeClass('header__mega-menu-nav-item--active');
            $(megaNav).find('.header__mega-menu-nav-content').removeClass('header__mega-menu-nav-content--active');
            $(event.currentTarget).addClass('header__mega-menu-nav-item--active');
            $(megaNav).find(".header__mega-menu-nav-content[data-section='" + section + "']").addClass('header__mega-menu-nav-content--active');
        });
        this.mobileMenuNavItem.click('click', function (event) {
            var section = $(event.currentTarget).data('accordion');
            if (_this.activeItem == section) {
                _this.activeItem = '';
                $(".header__mobile-menu-nav-secondary").removeClass('header__mobile-menu-nav-secondary--open');
                _this.mobileMenuNavItem.removeClass('header__mobile-menu-nav-item--open');
            }
            else {
                _this.activeItem = section;
                _this.mobileMenuNavItem.removeClass('header__mobile-menu-nav-item--open');
                $(event.currentTarget).addClass('header__mobile-menu-nav-item--open');
                $(".header__mobile-menu-nav-secondary").removeClass('header__mobile-menu-nav-secondary--open');
                $(".header__mobile-menu-nav-secondary[data-accordion='" + _this.activeItem + "']").addClass('header__mobile-menu-nav-secondary--open');
            }
        });
        this.mobileMenuNavSecondaryItem.click('click', function (event) {
            var section = $(event.currentTarget).data('accordion');
            if ($(event.currentTarget).hasClass('header__mobile-menu-nav-secondary-item--expanded')) {
                $(".header__mobile-menu-nav-item").removeClass('header__mobile-menu-nav-item--hide');
                $(event.currentTarget).removeClass('header__mobile-menu-nav-secondary-item--expanded');
                $(".header__mobile-menu-nav-tertiary").removeClass('header__mobile-menu-nav-tertiary-item--activemenu');
                _this.mobileMenuNavTertiaryItem.removeClass('header__mobile-menu-nav-tertiary-item--open');
                $(".header__mobile-menu-nav-quaternary").removeClass('header__mobile-menu-nav-quaternary--open');
            }
            if (_this.activeSecondaryItem == section) {
                _this.activeSecondaryItem = '';
                $(".header__mobile-menu-nav-secondary").removeClass('header__mobile-menu-nav-tertiary--open');
                _this.mobileMenuNavSecondaryItem.removeClass('header__mobile-menu-nav-secondary-item--open');
                $(".header__mobile-menu-nav-tertiary").removeClass('header__mobile-menu-nav-tertiary--open');
            }
            else {
                _this.activeSecondaryItem = section;
                _this.mobileMenuNavSecondaryItem.removeClass('header__mobile-menu-nav-secondary-item--open');
                $(event.currentTarget).addClass('header__mobile-menu-nav-secondary-item--open');
                $(".header__mobile-menu-nav-tertiary").removeClass('header__mobile-menu-nav-tertiary--open');
                $(".header__mobile-menu-nav-tertiary[data-accordion='" + _this.activeSecondaryItem + "']").addClass('header__mobile-menu-nav-tertiary--open');
                //$(".header__mobile-menu-nav-tertiary[data-accordion='" + this.activeSecondaryItem + "'] .header__mobile-menu-nav-tertiary-item").first().addClass('header__mobile-menu-nav-tertiary-item--open');
                //$(".header__mobile-menu-nav-tertiary[data-accordion='" + this.activeSecondaryItem + "'] .header__mobile-menu-nav-quaternary").first().addClass('header__mobile-menu-nav-quaternary--open');				
                //$(".header__mobile-menu-nav-tertiary[data-accordion='" + this.activeSecondaryItem + "'] .header__mobile-menu-nav-tertiary-item").first().click();				
                $(".header__mobile-menu__content").addClass('header__mobile-menu__content--expanded');
            }
        });
        this.mobileMenuNavTertiaryItem.click('click', function (event) {
            event.stopImmediatePropagation();
            var section = $(event.currentTarget).data('accordion');
            $(".header__mobile-menu-nav-item").addClass('header__mobile-menu-nav-item--hide');
            // $(".header__mobile-menu-top").hide();
            if (_this.activeTertiaryItem == section) {
                _this.activeTertiaryItem = '';
                $(".header__mobile-menu-nav-tertiary").removeClass('header__mobile-menu-nav-tertiary-item--activemenu');
                _this.mobileMenuNavTertiaryItem.removeClass('header__mobile-menu-nav-tertiary-item--open');
                $(".header__mobile-menu-nav-quaternary").removeClass('header__mobile-menu-nav-quaternary--open');
            }
            else {
                _this.activeTertiaryItem = section;
                _this.mobileMenuNavTertiaryItem.removeClass('header__mobile-menu-nav-tertiary-item--open');
                $(".header__mobile-menu-nav-tertiary").addClass('header__mobile-menu-nav-tertiary-item--activemenu');
                $(event.currentTarget).addClass('header__mobile-menu-nav-tertiary-item--open');
                $('.header__mobile-menu-nav-secondary-item--open').addClass('header__mobile-menu-nav-secondary-item--expanded');
                $(".header__mobile-menu-nav-quaternary").removeClass('header__mobile-menu-nav-quaternary--open');
                $(".header__mobile-menu-nav-quaternary[data-accordion='" + _this.activeTertiaryItem + "']").addClass('header__mobile-menu-nav-quaternary--open');
            }
        });
        this.mobileMenuNavTertiaryBack.click('click', function (event) {
            event.stopImmediatePropagation();
            event.preventDefault();
            _this.activeSecondaryItem = '';
            _this.activeTertiaryItem = '';
            // $(".header__mobile-menu-top").show();
            $(".header__mobile-menu__content").removeClass('header__mobile-menu__content--expanded');
            $(".header__mobile-menu-nav-item").removeClass('header__mobile-menu-nav-item--hide');
            $(".header__mobile-menu-nav-secondary").removeClass('header__mobile-menu-nav-tertiary--open');
            _this.mobileMenuNavSecondaryItem.removeClass('header__mobile-menu-nav-secondary-item--open');
            _this.mobileMenuNavSecondaryItem.removeClass('header__mobile-menu-nav-secondary-item--expanded');
            $(".header__mobile-menu-nav-tertiary").removeClass('header__mobile-menu-nav-tertiary--open');
            $(".header__mobile-menu-nav-tertiary").removeClass('header__mobile-menu-nav-tertiary--open');
            _this.mobileMenuNavTertiaryItem.removeClass('header__mobile-menu-nav-tertiary-item--open');
            $(".header__mobile-menu-nav-quaternary").removeClass('header__mobile-menu-nav-quaternary--open');
        });
        // group
        if (this.groupCountryTrigger) {
            this.groupCountryTrigger.map(function (item) { return item.addEventListener('click', function (event) {
                // change styling if country is selected
                _this.groupCountryInitContainer.map(function (container) {
                    _this.accountOpen = false;
                    container.classList.remove('header__mega-menu--account__split--white');
                    container.classList.add('header__mega-menu--account__split');
                });
                _this.groupCountryInitContainerNotSelected.map(function (container) {
                    container.classList.add('d-none');
                });
                _this.groupCountryInitContainerSelected.map(function (container) {
                    container.classList.remove('d-none');
                });
                // selected element
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var getCountry = element.getAttribute('data-country');
                var getCountryUrl = element.getAttribute('data-link');
                var getHTML = element.outerHTML;
                getHTML = getHTML.replace('header__mega-menu--account__split--countries', 'header__mobile-menu-account__split--country-selected');
                // change website link
                _this.groupCountryWebsite.map(function (link) {
                    link.setAttribute('href', getCountryUrl);
                });
                // get element html
                _this.groupCountrySelected.map(function (container) {
                    container.innerHTML = getHTML;
                });
                // show relevant container
                _this.groupCountryContainer.map(function (container) {
                    container.classList.add('d-none');
                    var getCountryContainer = container.getAttribute('data-country');
                    if (getCountryContainer === getCountry) {
                        container.classList.remove('d-none');
                    }
                });
                // remove relevant button once selected
                _this.groupCountryTrigger.map(function (trigger) {
                    var closestContainer = trigger.closest('div');
                    var getCountryContainer = trigger.getAttribute('data-country');
                    // if(closestContainer){
                    // 	if(getCountryContainer === getCountry){
                    // 		closestContainer.classList.add('d-none');
                    // 	}else{
                    // 		closestContainer.classList.remove('d-none');
                    // 	}
                    // }
                });
                // collapse countries
                if (!element.classList.contains('js-initial-load')) {
                    _this.groupCountryCollapse.map(function (trigger) {
                        trigger.click();
                    });
                }
                _this.groupCountryContainerLink.map(function (item) {
                    var newComponent = document.createElement('div');
                    newComponent.classList.add('header__animate-new-country');
                    item.appendChild(newComponent);
                    setTimeout(function () {
                        $('div.header__animate-new-country').remove();
                    }, 600);
                });
            }); });
        }
        if (this.mobileMenuNavLanguageSelector) {
            this.mobileMenuNavLanguageSelector.addEventListener('click', function (event) {
                if (_this.mobileMenuNavLanguageSelector.classList.contains('header__mobile-menu-language__button__opened')) {
                    _this.mobileMenuNavLanguageSelector.classList.remove('header__mobile-menu-language__button__opened');
                    _this.mobileMenuNavLanguageOverlay.classList.remove('header__mobile-menu-language__overlay--opened');
                }
                else {
                    _this.mobileMenuNavLanguageSelector.classList.add('header__mobile-menu-language__button__opened');
                    _this.mobileMenuNavLanguageOverlay.classList.add('header__mobile-menu-language__overlay--opened');
                }
            });
        }
        if (this.buttonLanguageSelectorDesktop) {
            this.buttonLanguageSelectorDesktop.addEventListener('click', function (event) {
                if (_this.containerLanguagesDesktop.classList.contains('header__top-bar-language__opened')) {
                    _this.containerLanguagesDesktop.classList.remove('header__top-bar-language__opened');
                }
                else {
                    _this.containerLanguagesDesktop.classList.add('header__top-bar-language__opened');
                }
            });
        }
        ////////////////////////////////////
        ////////////////////////////////////
        // drawer menu
        ////////////////////////////////////
        ////////////////////////////////////
        if (this.drawerButton) {
            this.drawerButton.addEventListener('click', function () {
                if (_this.drawerComponent.classList.contains('header__onlinebanking--opened')) {
                    // this.drawerComponent.classList.remove('header__onlinebanking--opened__active');
                    // setTimeout(() => {
                    // 	this.drawerComponent.classList.remove('header__onlinebanking--opened');
                    // }, 400);
                }
                else {
                    if (_this.drawerCartClose) {
                        _this.drawerCartClose.map(function (item) {
                            item.click();
                        });
                        setTimeout(function () {
                            _this.element.classList.add('header__onlinebanking--zindex');
                            _this.drawerComponent.classList.add('header__onlinebanking--opened');
                            setTimeout(function () {
                                _this.drawerComponent.classList.add('header__onlinebanking--opened__active');
                            }, 200);
                        }, 400);
                    }
                    else {
                        _this.element.classList.add('header__onlinebanking--zindex');
                        _this.drawerComponent.classList.add('header__onlinebanking--opened');
                        setTimeout(function () {
                            _this.drawerComponent.classList.add('header__onlinebanking--opened__active');
                        }, 200);
                    }
                }
            });
        }
        if (this.drawerClose) {
            this.drawerClose.map(function (item) { return item.addEventListener('click', function (event) {
                // element
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                // element
                // mobile
                if (element.closest('.header__mobile-menu__content')) {
                    _this.toggleAccountMobileMenu();
                }
                // mobile
                // desktop
                _this.drawerComponent.classList.remove('header__onlinebanking--opened__active');
                setTimeout(function () {
                    _this.drawerComponent.classList.remove('header__onlinebanking--opened');
                }, 400);
                // desktop
            }); });
            // this.drawerClose.addEventListener('click', ()=>{
            // 	this.drawerComponent.classList.remove('header__onlinebanking--opened__active');
            // 	setTimeout(() => {
            // 		this.drawerComponent.classList.remove('header__onlinebanking--opened');
            // 	}, 400);
            // })
        }
        if (this.drawerComponent) {
            this.drawerComponent.addEventListener('click', function (e) {
                var target = e.target;
                var closest = target.closest('.header__onlinebanking--container');
                if (closest) {
                }
                else {
                    _this.drawerComponent.classList.remove('header__onlinebanking--opened__active');
                    setTimeout(function () {
                        _this.drawerComponent.classList.remove('header__onlinebanking--opened');
                    }, 400);
                }
            });
        }
        if (this.headerOnlineBankingAccordion) {
            this.headerOnlineBankingAccordion.map(function (item) {
                var link = item.querySelector('a');
                link.addEventListener('click', function (event) {
                    var anchor;
                    if (event.currentTarget) {
                        anchor = event.currentTarget;
                    }
                    else {
                        anchor = event.target;
                    }
                    var label = anchor.closest('label');
                    label.click();
                });
            });
        }
        ////////////////////////////////////
        ////////////////////////////////////
        // drawer cart
        ////////////////////////////////////
        ////////////////////////////////////
        if (this.drawerCartButton) {
            this.drawerCartButton.addEventListener('click', function () {
                if (_this.drawerCartComponent.classList.contains('header__onlinebanking--cart--opened')) {
                    // this.drawerCartComponent.classList.remove('header__onlinebanking--cart--opened__active');
                    // setTimeout(() => {
                    // 	this.drawerCartComponent.classList.remove('header__onlinebanking--cart--opened');
                    // }, 400);
                }
                else {
                    if (_this.drawerClose) {
                        _this.drawerClose.map(function (item) {
                            item.click();
                        });
                        setTimeout(function () {
                            _this.element.classList.add('header__onlinebanking--cart--zindex');
                            _this.drawerCartComponent.classList.add('header__onlinebanking--cart--opened');
                            setTimeout(function () {
                                _this.drawerCartComponent.classList.add('header__onlinebanking--cart--opened__active');
                            }, 200);
                        }, 400);
                    }
                    else {
                        _this.element.classList.add('header__onlinebanking--cart--zindex');
                        _this.drawerCartComponent.classList.add('header__onlinebanking--cart--opened');
                        setTimeout(function () {
                            _this.drawerCartComponent.classList.add('header__onlinebanking--cart--opened__active');
                        }, 200);
                    }
                }
            });
        }
        if (this.drawerCartClose) {
            this.drawerCartClose.map(function (item) { return item.addEventListener('click', function (event) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                if (element.closest('.header__mobile-menu__content')) {
                    $('.header__mobile-menu__content').scrollTop(0);
                    $(".header__mobile-menu__content").removeClass('header__mobile-menu__content--expanded__onlinebanking');
                    $(".header__mobile-menu__content").removeClass('header__mobile-menu__content--expanded__onlinebanking--cart');
                    _this.mobileAccountMenu.removeClass("header__mobile-menu-account--open");
                    _this.mobileMenuNav.addClass("header__mobile-menu-nav--open");
                }
                _this.drawerCartComponent.classList.remove('header__onlinebanking--cart--opened__active');
                setTimeout(function () {
                    _this.drawerCartComponent.classList.remove('header__onlinebanking--cart--opened');
                }, 400);
            }); });
            // this.drawerCartClose.addEventListener('click', ()=>{
            // 	this.drawerCartComponent.classList.remove('header__onlinebanking--cart--opened__active');
            // 	setTimeout(() => {
            // 		this.drawerCartComponent.classList.remove('header__onlinebanking--cart--opened');
            // 	}, 400);
            // })
        }
        if (this.drawerCartComponent) {
            this.drawerCartComponent.addEventListener('click', function (e) {
                var target = e.target;
                var closest = target.closest('.header__onlinebanking--cart--container');
                if (closest) {
                }
                else {
                    _this.drawerCartComponent.classList.remove('header__onlinebanking--cart--opened__active');
                    setTimeout(function () {
                        _this.drawerCartComponent.classList.remove('header__onlinebanking--cart--opened');
                    }, 400);
                }
            });
        }
        if (this.drawerCartMobileMenuButton) {
            this.drawerCartMobileMenuButton.addEventListener('click', function (event) {
                $('.header__mobile-menu__content').scrollTop(0);
                $(".header__mobile-menu__content").removeClass('header__mobile-menu__content--expanded__onlinebanking');
                _this.mobileAccountMenu.removeClass("header__mobile-menu-account--open");
                if ($(".header__mobile-menu__content").hasClass('header__mobile-menu__content--expanded__onlinebanking--cart')) {
                    _this.mobileMenuNav.addClass("header__mobile-menu-nav--open");
                    $(".header__mobile-menu__content").removeClass('header__mobile-menu__content--expanded__onlinebanking--cart');
                }
                else {
                    _this.mobileMenuNav.removeClass("header__mobile-menu-nav--open");
                    $(".header__mobile-menu__content").addClass('header__mobile-menu__content--expanded__onlinebanking--cart');
                }
            });
        }
    };
    Header.prototype.scroll = function () {
        if ($(window).scrollTop() > 20) {
            $('.header').addClass("header--sticky");
        }
        else {
            $('.header').removeClass("header--sticky");
        }
    };
    Header.prototype.toggleMobileMenu = function () {
        this.open = !this.open;
        this.expanded = false;
        this.activeItem = '';
        this.activeSecondaryItem = '';
        this.activeTertiaryItem = '';
        this.mobileAccountMenu.removeClass("header__mobile-menu-account--open");
        if (this.open) {
            this.lastScrollTop = $(window).scrollTop();
            $('body').css({
                'overflow': 'hidden',
                'position': 'relative',
                'width': '100%'
            });
            document.getElementsByClassName('main')[0].addEventListener("touchmove", this.freezeVp, false);
            if (this.accountOpen) {
                this.toggleAccountMobileMenu();
            }
            this.hamburger.addClass("header__hamburger--open");
            $(this.element).addClass('header--open');
            this.mobileMenu.addClass("header__mobile-menu--open");
            this.mobileMenuNav.addClass("header__mobile-menu-nav--open");
        }
        else {
            $('body').css({
                'overflow': '',
                'position': '',
                'width': ''
            });
            $(window).scrollTop(this.lastScrollTop);
            document.getElementsByClassName('main')[0].removeEventListener("touchmove", this.freezeVp, false);
            $(this.element).removeClass('header--open');
            this.hamburger.removeClass("header__hamburger--open");
            this.mobileMenu.removeClass("header__mobile-menu--open");
            this.mobileMenuNav.removeClass("header__mobile-menu-nav--open");
        }
    };
    Header.prototype.freezeVp = function (e) {
        e.preventDefault();
    };
    ;
    Header.prototype.toggleAccountMobileMenu = function () {
        var headerMobileMenu = this.element.querySelector(".header__mobile-menu__content");
        if (MediaQueryService.getMediaQuery() === 'x-small') {
            $('.header__mobile-menu__content').scrollTop(0);
            this.accountOpen = !this.accountOpen;
            if (this.accountOpen) {
                if (headerMobileMenu.querySelector('.header__onlinebanking')) {
                    $(".header__mobile-menu__content").removeClass('header__mobile-menu__content--expanded__onlinebanking--cart');
                    $(".header__mobile-menu__content").addClass('header__mobile-menu__content--expanded__onlinebanking');
                    this.mobileMenuNav.removeClass("header__mobile-menu-nav--open");
                    this.mobileAccountMenu.removeClass("header__mobile-menu-account--open");
                }
                else {
                    $(".header__mobile-menu__content").removeClass('header__mobile-menu__content--expanded__onlinebanking--cart');
                    $(".header__mobile-menu__content").addClass('header__mobile-menu__content--expanded');
                    this.mobileMenuNav.removeClass("header__mobile-menu-nav--open");
                    this.mobileAccountMenu.addClass("header__mobile-menu-account--open");
                }
            }
            else {
                if (headerMobileMenu.querySelector('.header__onlinebanking')) {
                    $(".header__mobile-menu__content").removeClass('header__mobile-menu__content--expanded__onlinebanking--cart');
                    $(".header__mobile-menu__content").removeClass('header__mobile-menu__content--expanded__onlinebanking');
                    this.mobileMenuNav.addClass("header__mobile-menu-nav--open");
                    this.mobileAccountMenu.removeClass("header__mobile-menu-account--open");
                }
                else {
                    $(".header__mobile-menu__content").removeClass('header__mobile-menu__content--expanded__onlinebanking--cart');
                    $(".header__mobile-menu__content").removeClass('header__mobile-menu__content--expanded');
                    this.mobileMenuNav.addClass("header__mobile-menu-nav--open");
                    this.mobileAccountMenu.removeClass("header__mobile-menu-account--open");
                }
            }
        }
        else if (MediaQueryService.getMediaQuery() === 'medium-small' || MediaQueryService.getMediaQuery() === 'small') {
            $('.header__mega-menu--account').scrollTop(0);
            this.accountOpen = !this.accountOpen;
            if (this.accountOpen) {
                $(".header__mega-menu--account").addClass('header__mega-menu--open');
            }
            else {
                $(".header__mega-menu--account").removeClass('header__mega-menu--open');
            }
        }
    };
    Header.prototype.closeMobileMenu = function () {
        this.open = false;
        this.activeItem = '';
        this.activeSecondaryItem = '';
        this.activeTertiaryItem = '';
        this.expanded = false;
        this.hamburger.removeClass("header__hamburger--open");
        this.mobileMenu.removeClass("header__mobile-menu--open");
        this.mobileMenuNav.removeClass("header__mobile-menu-nav--open");
    };
    // quick fix for the BizConnect nav in header on Business Page
    Header.prototype.bizConnectFix = function () {
        var _bizConnectLink = null;
        var _bizConnectLinks = this.element.querySelectorAll("a");
        for (var k = 0; k < _bizConnectLinks.length; k++) {
            if (_bizConnectLinks[k].getAttribute('href') === '/southafrica/business/bizconnect') {
                _bizConnectLink = _bizConnectLinks[k];
                break;
            }
        }
        if (_bizConnectLink) {
            var _elemParent = _bizConnectLink.parentElement;
            if (_elemParent) {
                var _childDiv = _elemParent.querySelector("div.header__mega-menu");
                if (_childDiv) {
                    _elemParent.removeChild(_childDiv);
                }
            }
        }
    };
    // alert navigation changed
    Header.prototype.detectMobileHeaderContentHeight = function () {
        var windowHeight = window.screen.height;
        var alertHeight = 0;
        var openAppStoreHeight = 0;
        if (document.querySelector('.header__alert')) {
            var alertBanner = document.querySelector('.header__alert');
            alertHeight = alertBanner.clientHeight;
        }
        if (document.querySelector('.open-app-store')) {
            var openAppStore = document.querySelector('.open-app-store');
            openAppStoreHeight = openAppStore.clientHeight;
        }
        if (document.querySelector('.header__mobile-menu-language')) {
            var newHeight = (windowHeight - 210) - alertHeight - openAppStoreHeight;
            $('div.header__mobile-menu__content').css('min-height', newHeight + 'px');
            $('div.header__mobile-menu__content').css('max-height', newHeight + 'px');
        }
        else {
            var newHeight = (windowHeight - 160) - alertHeight - openAppStoreHeight;
            $('div.header__mobile-menu__content').css('min-height', newHeight + 'px');
            $('div.header__mobile-menu__content').css('max-height', newHeight + 'px');
        }
    };
    return Header;
}(Base));
export { Header };



//////////////////
// WEBPACK FOOTER
// ./components/header/header.component.ts
// module id = 344
// module chunks = 0